// Country IDs
import { AccountTypeIdEnum } from '../models/enum/shared/account-type-id.enum';
import { ProvinceIdEnum } from '../models/enum/shared/province-id-enum';
import { GoverningJurisdictionTypeId } from '../models/enum/shared/governing-jurisdiction-type-id';

export const CANADA_COUNTRY_ID = 1;
export const USA_COUNTRY_ID = 2;
export const UK_COUNTRY_ID = 236;

export const CANADA_COUNTRY_CODE = 'CA';

export const AGE_OF_MAJORITY_BY_PROVINCE_ID: Record<ProvinceIdEnum, number> = {
  [ProvinceIdEnum.Alberta]: 18,
  [ProvinceIdEnum.Manitoba]: 18,
  [ProvinceIdEnum.Ontario]: 18,
  [ProvinceIdEnum.PEI]: 18,
  [ProvinceIdEnum.Quebec]: 18,
  [ProvinceIdEnum.Saskatchewan]: 18,
  [ProvinceIdEnum.BC]: 19,
  [ProvinceIdEnum.NewBrunswick]: 19,
  [ProvinceIdEnum.Newfoundland]: 19,
  [ProvinceIdEnum.NovaScotia]: 19,
  [ProvinceIdEnum.NorthwestTerritories]: 19,
  [ProvinceIdEnum.Nunavit]: 19,
  [ProvinceIdEnum.Yukon]: 19
};

export const GOVERNING_JURISDICTION_NAMES: Record<GoverningJurisdictionTypeId, string> = {
  [GoverningJurisdictionTypeId.Alberta]: 'Alberta',
  [GoverningJurisdictionTypeId.BritishColumbia]: 'British Columbia',
  [GoverningJurisdictionTypeId.Manitoba]: 'Manitoba',
  [GoverningJurisdictionTypeId.NewBrunswick]: 'New Brunswick',
  [GoverningJurisdictionTypeId.NewfoundlandAndLabrador]: 'Newfoundland and Labrador',
  [GoverningJurisdictionTypeId.NovaScotia]: 'Nova Scotia',
  [GoverningJurisdictionTypeId.Ontario]: 'Ontario',
  [GoverningJurisdictionTypeId.Quebec]: 'Quebec',
  [GoverningJurisdictionTypeId.Saskatchewan]: 'Saskatchewan',
  [GoverningJurisdictionTypeId.Federal]: 'Federal'
};

export const CANADIAN_PROVINCE_SHORT_CODES = [
  'AB',
  'BC',
  'MB',
  'NB',
  'NL',
  'NS',
  'ON',
  'PE',
  'QC',
  'SK',
  'NT',
  'NU',
  'YT'
];

// Account Type Labels
export const AccountTypeLabels: Record<AccountTypeIdEnum, string> = {
  [AccountTypeIdEnum.DefinedContribution]: $localize`Defined Contribution`,
  [AccountTypeIdEnum.VariableBenefit]: $localize`Variable Benefit`,
  [AccountTypeIdEnum.MonthlyPension]: $localize`Monthly Pension`,
  [AccountTypeIdEnum.Retirement]: $localize`Retirement`,
  [AccountTypeIdEnum.Clearing]: $localize`Clearing`,
  [AccountTypeIdEnum.TransferredIn]: $localize`Transfer-In`
};

// CSS Form Library URL
export const CSS_FORM_LIBRARY_URL = 'https://csspension.com/form-library';

// CSS Contact URL
export const CSS_CONTACT_URL = 'https://csspension.com/contact-us';

// CSS Support Phone Number
export const CSS_SUPPORT_PHONE_NUMBER = '1 (306) 477-8500';

// CSS new member template link
export const CSS_NEW_MEMBER_TEMPLATE_LINK =
  'https://csspension-public-files.s3.ca-central-1.amazonaws.com/new_member_template.csv';
